/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/tabindex-no-positive */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useMemo, useState } from "react";
import ReactGA from "react-ga4";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { RootState } from "store";

// design
import "./navbar.scss";

// imgs
import { ReactComponent as HamMenu } from "design_system/src/static/icons/hamburger-menu.svg";
import { ReactComponent as Money } from "design_system/src/static/icons/money.svg";
import { ReactComponent as User } from "design_system/src/static/icons/user-card.svg";

import { Button, ScalableImage, Typography } from "design_system/src";
import {
  AllianceEnum,
  AllianceUrlEnum,
  CATALOG_ALLIANCES,
  getAlliance,
  getAllianceUrl,
} from "enums/alliance.enum";
import {
  clearApplicationLoanTime,
  clearApplicationPartnership,
  clearApplicationVehicle,
} from "store/actions/application";
import { Cities } from "../../../store/reducers/cityReducer";
import { AccountButton } from "./AccountButton";

type NavbarProps = {
  setOpenCityModal: Function;
};
export const Navbar: React.FC<NavbarProps> = ({ setOpenCityModal }) => {
  const dispatch = useDispatch();

  const tempToken = useSelector((state: RootState) => state.userReducer.tempToken);
  const accessToken = useSelector((state: RootState) => state.userReducer.accessToken);
  const isTempTokenSession = !!tempToken && !accessToken;
  const isAccessTokenSession = !!accessToken;

  const location = useLocation();
  const [sideBar, setSideBar] = useState<boolean>(false);
  const [url, setURL] = useState("");

  const alliance = useMemo<AllianceEnum | null>(() => {
    const match = location.pathname.match(
      /^\/([^/]+)\/(financia-tu-moto|catalogo(?:\/[^/]*)?)$/
    );

    if (match) {
      const alianza = match[1];
      const allianceValue = getAlliance(alianza as AllianceUrlEnum);
      if (allianceValue) {
        return allianceValue;
      }
    }

    return null;
  }, [location.pathname]);

  const formUrl = useMemo<string>(() => {
    if (alliance) return `${getAllianceUrl(alliance)}/financia-tu-moto`;
    return "/financia-tu-moto";
  }, [alliance]);

  const paths = useMemo<any[]>(() => {
    if (alliance && CATALOG_ALLIANCES.includes(alliance)) {
      return [];
    }

    return [
      {
        path: "/catalogo",
        label: "Compra tu moto",
      },
      {
        path: "/faqs",
        label: "Ayuda",
      },
    ];
  }, [alliance]);

  useEffect(() => {
    setURL(location.pathname);
  }, [location.pathname]);

  function toggleSideBar() {
    setSideBar(!sideBar);
  }

  function handleSidebar(selectedSection: string) {
    if (selectedSection === "/faqs") {
      ReactGA.event("CTA_navbar_FAQS", {
        category: "Support",
        label: "click faqs from navbar to FAQS view",
      });
    } else if (selectedSection === "/catalogo") {
      ReactGA.event("CTA_catalog_navbar", {
        category: "Marketplace",
        label: "click catalog from navbar to catalog view",
      });
    } else {
      ReactGA.event("CTA_navbar_icon", {
        category: "Support",
        label: "click ozon´s icon button to home view (/)",
      });
    }
  }

  const city = localStorage.getItem("city");

  useEffect(() => {
    if (city !== Cities.CDMX) {
      localStorage.setItem("city", Cities.CDMX);
    }
  }, [city]);

  const goLoan = () => {
    dispatch(clearApplicationLoanTime());
    dispatch(clearApplicationVehicle());
    dispatch(clearApplicationPartnership());
  };

  return (
    <div
      className="pos_fixed display_block"
      style={{ zIndex: 999, width: "100%" }}
    >
      <header className="navbar shadow_medium ">
        <div className="main-container">
          <div
            className="display_flex"
            style={{ justifyContent: "start", alignItems: "center" }}
          >
            <Link to="/" className="custom_a">
              <figure className="m_none">
                <ScalableImage
                  src="https://ik.imagekit.io/ozon/Compartidos/Logos/logo_ozon"
                  alt="Ozon - Compra y financia tu moto en Ciudad de México"
                  className="h_xl"
                  desktopWidth={5}
                  mobileWidth={5}
                />
              </figure>
            </Link>
            <Typography scale="small" weight="600" className="pr_lg">
              by
            </Typography>
            <Link to="https://www.payjoy.com/mx" className="custom_a h_xl">
              <ScalableImage
                src="https://ik.imagekit.io/ozon/Homepage/Logos/logo_payjoy.jpg"
                alt="PayJoy - Financiamiento"
                className="h_xl"
                desktopWidth={5}
                mobileWidth={5}
              />
            </Link>
          </div>

          {(!alliance || !location.pathname.includes("financia-tu-moto")) && (
            <Button
              className="display_none_desktop"
              variant="icon"
              scale="small"
              subvariant="edit"
              icon={<HamMenu />}
              onClick={toggleSideBar}
            />
          )}
          <div
            className={`backdrop display_none_desktop ${sideBar ? "open" : ""}`}
            onClick={toggleSideBar}
            tabIndex={0}
          >
            <div className="sidebar" tabIndex={1}>
              <Link to="/" className="custom_a">
                <figure className="m_none">
                  <ScalableImage
                    src="https://ik.imagekit.io/ozon/Compartidos/Logos/logo_ozon"
                    alt="Ozon - Compra y financia tu moto en Ciudad de México"
                    className="m_y_xxxl center_x h_xl"
                    desktopWidth={5}
                    mobileWidth={5}
                  />
                </figure>
              </Link>

              <nav className="flex_center_col flex_align_start p_xxl ">
                <div
                  className="dim_100_per flex_center flex_col m_b_xs p_b_xl w_100_per"
                  style={{ borderBottom: "1px solid #E0E3E5" }}
                >
                  {!alliance && (
                    <AccountButton className="m_b_sm w_100_per" fullWidth />
                  )}

                  {!isAccessTokenSession && (
                    isTempTokenSession ? (
                      <Link
                        to="/mi-cuenta"
                        onClick={goLoan}
                        className="custom_a w_100_per"
                      >
                        <Button
                          variant="principal"
                          color="primary"
                          icon={<User />}
                          scale="small"
                          className="w_100_per"
                        >
                          Acceder a mi cuenta
                        </Button>
                      </Link>
                      ) : (
                      <Link
                        to={formUrl}
                        onClick={goLoan}
                        className="custom_a w_100_per"
                      >
                        <Button
                          variant="principal"
                          color="primary"
                          icon={<Money />}
                          scale="small"
                          className="w_100_per"
                        >
                          Solicita tu crédito ya
                        </Button>
                      </Link>
                      )
                  )}
                </div>
                {paths.map((ele) => {
                  return (
                    <Link
                      to={ele.path}
                      onClick={() => handleSidebar(ele.path)}
                      key={ele.path}
                      className="custom_a"
                    >
                      <Button
                        variant="link"
                        className={`${ele.path === url ? "active" : ""} m_b_md`}
                        scale="small"
                      >
                        {ele.label}
                      </Button>
                    </Link>
                  );
                })}
              </nav>
            </div>
          </div>
          <nav className="flex_center flex_justify_end flex_grow_1 display_none_mobile pos_relative">
            {paths.map((ele) => {
              return (
                <Link
                  to={ele.path}
                  onClick={() => handleSidebar(ele.path)}
                  key={ele.path}
                  className="custom_a"
                >
                  <Button
                    variant="link"
                    className={`${
                      ele.path === url ? "m_r_xxxl active" : "m_r_xxxl"
                    }`}
                    scale="small"
                  >
                    {ele.label}
                  </Button>
                </Link>
              );
            })}

            {(!alliance || !location.pathname.includes("financia-tu-moto")) && (
              <>
                {!isAccessTokenSession && (
                  isTempTokenSession ? (
                    <Link
                      to="/mi-cuenta"
                      onClick={goLoan}
                      className="custom_a"
                    >
                      <Button
                        variant="principal"
                        color="primary"
                        onClick={goLoan}
                        icon={<User />}
                        scale="small"
                      >
                        Acceder a mi cuenta
                      </Button>
                    </Link>
                  ) : (
                    <Link
                      to={formUrl}
                      onClick={goLoan}
                      className="custom_a"
                    >
                      <Button
                        variant="principal"
                        color="primary"
                        icon={<Money />}
                        onClick={goLoan}
                        scale="small"
                      >
                        Solicita tu crédito ya
                      </Button>
                    </Link>
                  )
                )}

                {!alliance && <AccountButton className="m_l_sm" />}
              </>
            )}
          </nav>
        </div>
      </header>
    </div>
  );
};
